import React, { useState, useEffect, useCallback } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import BaseContainer from '../common/BaseContainer';
import ControlHeader from '../common/ControlHeader';
import CampaignForm from './CampaignForm';
import Loading from '../common/icons/Loading';

import fetch from '../../utils/fetcher';
import { baseUrl, getRequestToFormData, getFormToRequestData } from './config';
import {
  translateQuestionsDictionary,
  translateQuestionsReverseDictionary,
} from '../CampaignFormQuestionnaire/AddQuestionModalContent/questionTypesConsts';
import { useVisible } from '../common/AlertManager';
import useStyles from './styles';


const EditCampaign = () => {
  const [alertError, setAlertError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [values, setValues] = useState(null);
  const [loading, setLoading] = useState(true);
  const { visible: isErrorVisible, open: openError } = useVisible(false);
  const { t } = useTranslation(['translation'])
  const classes = useStyles();

  const QUESTIONS_DICTIONARY = translateQuestionsDictionary(t);

  const formToRequestData = getFormToRequestData(QUESTIONS_DICTIONARY);
  const requestToFormData = useCallback(initialData => {
    const questionsReverseDictionary = translateQuestionsReverseDictionary(t);
    return getRequestToFormData(questionsReverseDictionary)(initialData);
  }, [t]);

  const { id } = useParams();
  const url = `${baseUrl}/${id}`;

  useEffect(() => {
    setIsSubmitting(true);
    fetch(url).then(res => res.json()).then(initialData => {
      setValues(requestToFormData(initialData));
    }).catch(e => {
      openError();
      setAlertError(e);
    })
      .finally(() => {
        setLoading(false);
        setIsSubmitting(false);
      });
  }, [url, requestToFormData]);

  const onSubmit = data => {
    fetch(url, formToRequestData(data, true)).then(() => {
      setSubmitted(true);
    }).catch(e => {
      openError();
      setAlertError(e);
    });
  };

  if (submitted) {
    return <Redirect to="/campaigns" />;
  }

  return (
    <BaseContainer>
      <ControlHeader
        title={t('CAMPAIGN.EDIT_CAMPAIGN_TITLE')}
        showBack
        overriddenClasses={{ titlePart: classes.campaignTitlePart }}
        goBackUrl="/campaigns"
      />
      {loading && <Loading /> }
      {!loading && (
        <CampaignForm
          values={values}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          alertError={alertError}
          buttonText={t('CAMPAIGN.EDIT_CAMPAIGN_SUBMIT_BUTTON_TEXT')}
          campaignId={id}
          editMode
          isErrorVisible={isErrorVisible}
        />
      )}
    </BaseContainer>
  );
};


export default EditCampaign;
